var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatajob(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "80.000000pt",
    height: "80.000000pt",
    viewBox: "0 0 80.000000 80.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,80.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292 712 c-141 -51 -231 -190 -220 -337 10 -117 80 -220 187 -272 48 -24 68 -28 141 -28 73 0 93 4 141 28 67 32 132 99 162 165 16 36 21 67 22 132 0 73 -4 93 -28 141 -32 67 -100 132 -165 162 -66 29 -172 33 -240 9z m245 -35 c58 -30 113 -86 144 -147 33 -64 33 -184 1 -256 -29 -64 -92 -126 -157 -156 -63 -29 -180 -31 -239 -5 l-40 18 53 53 c49 49 57 54 107 58 104 9 173 99 150 194 l-7 27 -47 -46 c-38 -38 -52 -45 -72 -40 -35 8 -47 20 -53 51 -5 22 2 35 40 74 l46 47 -27 7 c-95 23 -185 -46 -194 -150 -4 -50 -9 -58 -58 -107 l-53 -53 -18 40 c-27 60 -24 186 6 244 43 83 122 149 206 171 54 15 159 2 212 -24z m-151 -175 c-37 -39 -37 -39 -26 -85 11 -42 15 -46 57 -57 46 -11 46 -11 85 26 l38 38 0 -29 c0 -71 -74 -137 -148 -133 -40 2 -46 -2 -105 -60 l-63 -62 -42 43 -42 43 63 62 c59 59 62 64 59 104 -5 74 62 148 133 148 l29 0 -38 -38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390 670 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 590 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580 590 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 400 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660 400 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580 210 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390 130 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 310 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 280 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatajob);
export default __webpack_public_path__ + "static/media/datajob.ce81b12035c26f25959490b962619bf8.svg";
export { ForwardRef as ReactComponent };